import React, { FC } from 'react';
import { Box, BoxProps } from './Box';

export const Divider: FC<BoxProps> = (props) => (
    <Box backgroundColor="var(--divider)" height="1px" width="100%" {...props}></Box>
);
